const createNamedActions = (namespace) => {
  const namespaceUpper = namespace.toUpperCase()
  const actionNames = {
    TOGGLE_FOLLOW_ENTITY: `${namespaceUpper}:TOGGLE_FOLLOW_ENTITY`,
    TOGGLE_FOLLOW_ENTITY_PROGRESS: `${namespaceUpper}:TOGGLE_FOLLOW_ENTITY_PROGRESS`,
    FOLLOW_ENTITY_SUCCESS: `${namespaceUpper}:FOLLOW_ENTITY_SUCCESS`,
    UNFOLLOW_ENTITY_SUCCESS: `${namespaceUpper}:UNFOLLOW_ENTITY_SUCCESS`,
    FOLLOW_ENTITY_FAILURE: `${namespaceUpper}:FOLLOW_ENTITY_FAILURE`,
    UNFOLLOW_ENTITY_FAILURE: `${namespaceUpper}:UNFOLLOW_ENTITY_FAILURE`,
    FETCH_SUBSCRIBERS_SUCCESS: `${namespaceUpper}:FETCH_SUBSCRIBERS_SUCCESS`,
  }

  const toggleFollowEntity = (identifier, type) => {
    return {
      type: actionNames.TOGGLE_FOLLOW_ENTITY,
      identifier,
      identifierType: type,
    }
  }

  return {
    actionNames,
    toggleFollowEntity,
  }
}

export default createNamedActions
